$(function () {

	// スクロールアニメーション
	new WOW().init();


	//メインビジュアル
	$('.mv_swiper').imagesLoaded( function() {
		//メインビジュアルスライドショ
		$('.mv_loading').hide();
		var mySwiper = new Swiper('.mv_swiper', {
			loop: true,
			speed: 1000,
			effect: 'fade',
			allowTouchMove: false,
			autoplay: {
				delay: 500,
			},
		});
	});

	//ピックアップスライドショー
	var swiper = new Swiper(".pickup_swiper", {
		loop: true,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			320: {
				slidesPerView: 1.2,
				spaceBetween: 20,
			},
			// 768px以上の場合
			767: {
				slidesPerView: 'auto',
				spaceBetween: 30,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}
	});

	//インタビュースライドショー
	var swiper = new Swiper(".interview_swiper", {
		loop: true,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}
	});



});